<template>
<p>Signing out...</p>
</template>
<script>
import { auth, db } from '@/firebase';
import store from '@/stores/store'
export default {

    name: 'Logout',

    mounted() {
        this.signOut()
    },

    methods: {
       signOut() {
           //const auth = auth.getAuth();
           auth.signOut().then(() => {
               store.dispatch('fetchUser', null);
               this.$router.push('/');
           }).catch((error) => {
               alert("Something went, we could not log you out.")
           })
       }
    }
}
</script>